import { render, staticRenderFns } from "./MkObj.vue?vue&type=template&id=588255f2&"
import script from "./MkObj.vue?vue&type=script&lang=js&"
export * from "./MkObj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports